import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  withCredentials: true,
  timeout: 60000, // 60 seconds — handles Render free tier cold start
});

// Add token to every request as Bearer header
// Reads directly from Zustand store state (most up-to-date)
// Falls back to localStorage in case store isn't loaded yet
api.interceptors.request.use((config) => {
  try {
    // First try to get token directly from Zustand store (always up to date)
    let token = null;

    // Try dynamic import from store
    try {
      const { default: useAuthStore } = require("../store/authStore");
      token = useAuthStore.getState().token;
    } catch (_) {}

    // Fallback: read from localStorage
    if (!token) {
      const stored = localStorage.getItem("chatify-auth");
      if (stored) {
        const parsed = JSON.parse(stored);
        token = parsed?.state?.token;
      }
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) {}
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const authPaths = ["/login", "/register", "/verify-otp", "/verify-2fa"];
      const onAuthPage = authPaths.some((p) =>
        window.location.pathname.startsWith(p)
      );
      if (!onAuthPage) {
        try {
          const { default: useAuthStore } = await import("../store/authStore");
          useAuthStore.setState({ user: null, token: null });
        } catch (_) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
